import { VersionCardProps } from '@/components/cards/VersionCard';
import { CookieHelper } from '@/helpers/CookieHelper';

const useActiveBlockVersionFromCookie = (name: string) => {
  const cookieQuery = CookieHelper.GetCookie('x-block-config');

  const splitCookie = cookieQuery?.split('&');

  const strMatches = splitCookie?.filter((el: string) => {
    if (el.includes(name)) return true;
  });

  const getBranch = () => {
    let branch = '';
    strMatches?.map((el: string) => {
      if (el.includes('branch=')) branch = el.split('=')[1];
    });
    return branch;
  };

  const getVersion = () => {
    let version = '';
    strMatches?.map((el: string) => {
      if (el.includes('versionno=')) version = el.split('=')[1];
    });
    return version;
  };

  return {
    name,
    branch: getBranch(),
    version: getVersion(),
  };
};

const setCookieQuery = (
  selected: { blockId: string; versionNo: string } & VersionCardProps,
  prevQuery?: string
) => {
  const blocksChangedCookie = CookieHelper.GetCookie('x-blocks-changed'); // Blocks Changed Cookie
  const blocksChanged = blocksChangedCookie
    ? JSON.parse(blocksChangedCookie)
    : []; // Parse so we can read value

  const { id, blockId, versionNo } = selected || {};
  let newQuery = '';

  const blocksChangedUpdated = [...new Set([...blocksChanged, blockId])];
  const queryForNotMasterOrMain = `block-${blockId}-branch=${id}`;
  const queryForMasterOrMain = `block-${blockId}-branch=${id}&block-${blockId}-versionno=${versionNo}`;

  if (prevQuery) {
    if (id !== 'master' && id !== 'main') {
      newQuery = `${prevQuery}&${queryForNotMasterOrMain}`;
    } else {
      newQuery = `${prevQuery}&${queryForMasterOrMain}`;
    }
  } else if (!prevQuery) {
    if (id !== 'master' && id !== 'main') {
      newQuery = `${queryForNotMasterOrMain}`;
    } else {
      newQuery = `${queryForMasterOrMain}`;
    }
  }
  if (newQuery) {
    CookieHelper.SetCookie('x-block-config', decodeURI(newQuery));
    // Keeping the same prefix 'x' for the block cookie's
    CookieHelper.SetCookie(
      'x-blocks-changed',
      JSON.stringify(blocksChangedUpdated)
    );
  }
};

export { useActiveBlockVersionFromCookie, setCookieQuery };
